import { CommonModule } from "@angular/common";
import { Component, Input, inject } from "@angular/core";
import { I_HistoryItem } from "@models/I_HistoryItem";
import { I_HistoryItemRow } from "@models/I_HistoryItemRow";
import { parseTypeEnum } from "@models/MasterData";
import { TranslateModule } from "@ngx-translate/core";
import { ExtractDatePipe } from "@pipes/extractDate.pipe";
import { ParseMoney } from "@pipes/parseMoney";

@Component({
  selector: "page-cashier-history-detail-rows",
  templateUrl: "./cashier-history-detail-rows.html",
  styleUrls: ["./cashier-history-detail-rows.scss"],
  standalone: true,
  imports: [TranslateModule, CommonModule],
})
export class CashierHistoryDetailRowsPage {
  @Input() historyItemRows?: I_HistoryItemRow[];
  @Input() history?: I_HistoryItem;

  parseTypeEnum = parseTypeEnum;

  public extractDate = inject(ExtractDatePipe);
  public parseMoney = inject(ParseMoney);

  getFieldValue(historyItemRow: I_HistoryItemRow): string {
    const { field, suffix = "", parseType } = historyItemRow;
    const historyValue = this.history?.[field] ?? "";

    let fieldValue = `${historyValue}${suffix}`;

    if (parseType) {
      switch (parseType) {
        case parseTypeEnum.currency:
          fieldValue = `${this.parseMoney.transform(historyValue)}${suffix}`;
          break;
        case parseTypeEnum.date:
          fieldValue = `${this.extractDate.transform(historyValue, [2])}${suffix}`;
          break;
        default:
          break;
      }
    }

    return fieldValue;
  }
}
